// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__39mX-","footer":"ModalFilter_footer__1TKrk"};